// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Modal_overlay__1UPUU","modal":"Modal_modal__HQB-J","modalContent":"Modal_modalContent__1X8R6","contentCross":"Modal_contentCross__OF_L-"};